/** @jsxImportSource theme-ui */
import { Flex, get, Theme, ThemeUICSSObject } from 'theme-ui';
import React from 'react';

interface Props {
    inline?: boolean;
}

const inlineStyle: ThemeUICSSObject = {
    gap: 2,
    '> *': { flexGrow: 1 },
};

const regularStyle: ThemeUICSSObject = {
    flexDirection: 'column',
};

const FieldGroup: React.FC<Props> = ({ children, inline }) => {
    return <Flex sx={inline ? inlineStyle : regularStyle}>{children}</Flex>;
};

export default FieldGroup;
